import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { connect } from "react-redux";
// material
import {
    Card,
    Stack,
    TextField,
    Container,
    Typography,
    MenuItem
} from '@mui/material';
import { ListHead, ListToolbar, MoreMenu } from '../../components/_dashboard/car';
import { LoadingButton } from '@mui/lab';
import Scrollbar from '../../components/Scrollbar';
import { createProformaInvoice } from '../../actions/proformaInvoiceAction';
import { fetchAccountsDropdown } from '../../actions/accountAction';
import _ from 'lodash';
import Page from '../../components/Page';
import { styled } from '@mui/material/styles';
import Edit from "@material-ui/icons/Edit";
import DeleteOutlined from "@material-ui/icons/DeleteOutlined";
import ModalCompoennt from '../Portal/ModalCompoennt';


// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 680,
    margin: 'auto',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
}));

function CreateProformaInvoice(props) {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [openUpdate, setOpenUpdate] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const AddSchema = Yup.object().shape({
        account_id: Yup.string().required('Account is required'),
    });

    const formik = useFormik({
        initialValues: {
            account_id: ''
        },
    validationSchema: AddSchema,
        onSubmit: (values, {resetForm}) => {
            resetForm();
            setIsLoading(true);
            values.car_detail_id = props.carObj.carObj.id;
            props.createProformaInvoice(values);
        }
    });

    useEffect(() => {
        props.fetchAccountsDropdown();
        if(props.alerts.status == 'success') {
            navigate('/dashboard/proforma/invoices', { replace: true });
        }
    },[props.alerts])

    useEffect(() => {
        setIsLoading(false);
        if(props.alerts.status == 'success') {
            props.onDismis();
        }
    }, [props.alerts]);

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

    return (
        <Page title="Create Invoice">
            <Container maxWidth="lg" sx={{width:"50%"}}>
                <Card sx={{padding:"1em"}}>
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Typography variant="h7" gutterBottom>
                                <b>Car Name:</b> {!_.isEmpty(props.carObj.carObj) && props.carObj.carObj.motor}
                            </Typography>
                            <Typography gutterBottom>
                                <b>Chasis No:</b> {!_.isEmpty(props.carObj.carObj) && props.carObj.carObj.chasis_no}
                            </Typography>
                            <Typography gutterBottom>
                                <b>Select Account</b>
                            </Typography>
                            <Stack spacing={3}>
                                <TextField
                                    fullWidth
                                    select
                                    label="Select*"
                                    {...getFieldProps('account_id')}
                                    error={Boolean(touched.account_id && errors.account_id)}
                                    helperText={touched.account_id && errors.account_id}
                                >
                                    {props.accountsDropdown.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Stack>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
                            </Stack>

                            <LoadingButton
                                size="medium"
                                type="submit"
                                variant="contained"
                                loading={isLoading}
                                sx={{backgroundColor: '#c29136',float:"right", marginTop:"30px"}}
                            >
                                Create Invoice
                            </LoadingButton>
                        </Form>
                    </FormikProvider>
                </Card>
            </Container>
        </Page>
    );
}
const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        alerts: state.alerts,
        accountsDropdown:Object.values(state.accountDropdown)
    }
}

export default connect(mapStateToProps, { createProformaInvoice, fetchAccountsDropdown })(CreateProformaInvoice);

